import { initMenuMobile } from "./menuMobile";
import { initSliders } from "./sliders";
import { initSidePopup } from "./sidePopup";
import { initMapLoader } from "./mapLoader";
import { initStickyEstimate } from "./sticky-estimate";
import { sharePost } from "./sharePost";
import { initGalleryLightbox } from "./galleryLightbox";
import { initGalleryLoadMore } from "./galleryLoadMore";
import { initHeroFormScroll } from "./heroFormScroll";
import { initQuickQuoteRelocate } from "./quickQuoteRelocate";
import { initReviewVideosSlider } from "./reviewVideosSlider";

import "./pdm-feature-flags.js";

document.addEventListener("DOMContentLoaded", function () {
  // Imported functions here
  initSliders();
  initMenuMobile();
  initSidePopup();
  initMapLoader();
  initStickyEstimate();
  sharePost();
  initGalleryLightbox();
  initGalleryLoadMore();
  initHeroFormScroll();
  initQuickQuoteRelocate();
  initReviewVideosSlider();
});
